var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4766 2.35156C12.8437 1.98438 12.8437 1.39062 12.4766 1.02734C12.1094 0.664062 11.5156 0.660156 11.1523 1.02734L6.50391 5.67578L1.85156 1.02344C1.48438 0.65625 0.890625 0.65625 0.527344 1.02344C0.164062 1.39062 0.160156 1.98437 0.527344 2.34766L5.17578 6.99609L0.523438 11.6484C0.15625 12.0156 0.15625 12.6094 0.523438 12.9727C0.890625 13.3359 1.48438 13.3398 1.84766 12.9727L6.49609 8.32422L11.1484 12.9766C11.5156 13.3437 12.1094 13.3437 12.4727 12.9766C12.8359 12.6094 12.8398 12.0156 12.4727 11.6523L7.82422 7.00391L12.4766 2.35156Z",
    fill: "#323130"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.5f243eb34efd83d1f14c0c30f1299e5a.svg";
export { ForwardRef as ReactComponent };